import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get Users Accounts List
export const getUsersAccountsList = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get-users-accounts-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: [
          {
            id,
            name,
            email,
            role,
            phone,
            is_active,
            ...
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Change User Account Status (Activate / Deactivate)
export const changeUserAccountStatus = async (userId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(`/admin/active-users-account-status/${userId}`, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: { ...user, is_active: 0 أو 1 },
        message: "..." (حسب الباك)
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
